<template>
    <CheckRoleDialog
            :dialogTitle="dialogTitle"
            :centerDialogVisible="visible"
            @updateVisible="updateVisible"
            @resetPopupData="resetPopupData"
            @submitPopupData="submitPopupData"
            :popupWidth="'600px'"
    >
        <el-form label-width="120px">
            <el-form-item label="角色名称:" prop="roleName">
                <span>{{roleData.roleName}}</span>
            </el-form-item>
            <el-form-item label="角色描述:" prop="roleDesc">
                <span>{{roleData.remark}}</span>
            </el-form-item>
            <el-form-item label="已有权限" prop="roleAuth">
                <div style="overflow-y: auto;height: 300px">
                    <el-tree
                            :data="authTree"
                            :props="defaultProps"
                            :default-expand-all="true"
                    ></el-tree>
                </div>
            </el-form-item>
        </el-form>
    </CheckRoleDialog>
</template>

<script>
    import CheckRoleDialog from '../../../../components/common/epecDialog'
    import Api from '../../api/authority/index'
    export default {
        name: "checkRoleDialog",
        components: {
            CheckRoleDialog
        },
        props: {
            visible:{
                type:Boolean,
                required:true
            },
            roleData:{
                type:Object,
                required: true
            }
        },
        data() {
            return {
                dialogTitle:'查看角色',
                authTree:[],
                defaultProps: {
                    children: 'childList',
                    label: 'authName'
                },
            }
        },
        computed: {},
        created() {
            this.getRoleAuth()
        },
        methods: {
            updateVisible(){

            },
            resetPopupData(){
                this.$emit('close')
            },
            submitPopupData(){

            },
            getRoleAuth(){
                let params = {
                    roleId: this.roleData.roleId
                }
                Api.checkAuth(params)
                    .then((res) => {
                        if(res.code == '200'){
                            console.log(res.data)
                            this.authTree.push(res.data)
                        }

                    })
            }
        }

    }
</script>

<style scoped>

</style>
